module.exports = __webpack_public_path__ + "img/onlineConsult.b5b6fae7.png";